/* eslint-disable no-unused-vars */
import { db } from '@/services/firebase.service'

import SurveyService from '@/services/survey.service'

const state = {
  surveys: [],
  survey: null,
  loading: false,
}

const getters = {}

const mutations = {
  SET_SURVEYS(state, surveys) {
    state.surveys = surveys
  },
  SET_SURVEY(state, survey) {
    state.survey = survey
  },
  ADD_SURVEY(state, survey) {
    state.surveys.push(survey)
  },
  REMOVE_SURVEY(state, id) {
    state.surveys = state.surveys.filter((s) => s.id !== id)
  },
  SET_LOADING(state, flag) {
    state.loading = flag
  },
}

const actions = {
  init({ commit }) {
    let surveysRef = db.collection('surveys')

    surveysRef.onSnapshot(function (querySnapshot) {
      var surveys = []
      querySnapshot.forEach(function (doc) {
        surveys.push({ id: doc.id, ...doc.data() })
      })
      commit('SET_SURVEYS', surveys)
    })

    surveysRef.onSnapshot(function (snapshot) {
      snapshot.docChanges().forEach(function (change) {
        if (change.type === 'modified') {
          // console.log('Modified survey: ', change.doc.data())
        }
        if (change.type === 'removed') {
          commit('REMOVE_SURVEY', change.doc.id)
        }
      })
    })
  },

  create({ commit }, data) {
    return new Promise((resolve, reject) => {
      let survey = {
        ...data,
        created_at: new Date(),
        updated_at: null,
      }

      db.collection('surveys')
        .add(survey)
        .then(function (docRef) {
          // console.log('Document written with ID: ', docRef.id)
          resolve()
        })
        .catch(function (error) {
          console.error('Error adding document: ', error)
          reject(error)
        })
    })
  },

  async get({ commit }, id) {
    commit('SET_LOADING', true)
    try {
      const survey = await SurveyService.getSurvey(id)
      return survey
    } catch (error) {
      console.error(error)
      throw new Error(error)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async update({ commit, dispatch }, { id, data }) {
    commit('SET_LOADING', true)
    try {
      await SurveyService.updateSurvey(id, data)
      // dispatch(
      //   'notification/showMessage',
      //   {
      //     text: 'Questionario aggiornato con successo!',
      //     color: 'success',
      //     timeout: 2500,
      //   },
      //   { root: true }
      // )
    } catch (error) {
      console.error(error)
      dispatch(
        'notification/showMessage',
        {
          text: error,
          color: 'error',
          timeout: 3500,
        },
        { root: true }
      )
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async delete({ commit }, id) {
    commit('SET_LOADING', true)
    try {
      await SurveyService.deleteSurvey(id)
    } catch (error) {
      console.error(error)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async bulkCreate({ commit }, data) {
    commit('SET_LOADING', true)
    try {
      await SurveyService.bulkCreate(data)
    } catch (error) {
      console.error(error)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async bulkDelete({ commit }, data) {
    commit('SET_LOADING', true)
    try {
      await SurveyService.bulkDelete(data)
    } catch (error) {
      console.error(error)
    } finally {
      commit('SET_LOADING', false)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
